/* eslint-disable react-hooks/exhaustive-deps */
import { FC, Fragment, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { siteUrl } from "..";
import { Routes } from "../../../../../../AppRoutes";
import { CreateNotification } from "../../../../../../components/notifier";
import { approverType } from "../../../../../../constants/itCodeRequestConstants";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../../../constants/statusConstants";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { Button } from "../../../../../../modules/button";
import { MailService } from "../../../../../../services/mail/mail.service";
import { useSelector } from "../../../../../../store/store";
import ButtonGroup from "../../../../components/ButtonGroup";
import ButtonLayout from "../../../../components/ButtonLayout";
import { useProcess } from "../../../../process-context";
import { AssetService } from "../../../../../../services/department-viags/asset.service";
import { useEmployee, useUser } from "../../../../../../hook";
import { useUpdateRTR } from "../../hooks/use-update-RTR";
import { useQueryClient } from "@tanstack/react-query";

interface Props {
  assignList: any;
  selectedITHead: any;
  assignee: any;
}

const FormButton: FC<Props> = (props) => {
  const { assignList, selectedITHead, assignee } = props;
  const { Request, approvalStep, approvalType, comment } = useProcess();
  const { email, checkCurrentUser, name } = useUser();
  const { getEmployeesByEmail } = useEmployee();
  const admin = [
    "thiennv@viags.vn",
    "trungdt@viags.vn",
    "canbo1@viags.vn",
    "hieppt@viags.vn",
    "phuocvd@viags.vn",
    "hantt@viags.vn",
    "lapdt@viags.vn",
    "quynhvtn@viags.vn",
    "trungnn@viags.vn",
  ];
  const isAdmin = admin.includes(email?.toLowerCase());
  const isThiennv = email?.toLowerCase() === "thiennv@viags.vn";
  const listTSCC = Request.fields.ECodeTCSSId?.split("; ");
  const history = useHistory();
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const { mutate } = useUpdateRTR();
  const queryClient = useQueryClient();

  const checkEdit = () => {
    return (
      !Request.fields.eApprovedStatus && !Request.fields.eApprovedByITHeadStatus && !Request.fields.eAssigneeStatus
    );
  };

  const checkCreatedUser = () => {
    return checkCurrentUser(Request.createdBy.user.email.toLowerCase());
  };

  const checkApproval = () => {
    const { eApprovedByITHeadStatus, eAssigneeStatus, eRequestStatus } = Request.fields;
    if (eRequestStatus === requestStatus.rejected || eRequestStatus === requestStatus.completed) {
      return false;
    } else {
      if (approvalStep === approvalType) {
        return true;
      } else if (isThiennv) {
        return true;
      } else {
        if (approvalStep - approvalType === 1) {
          switch (approvalStep) {
            // case approverType.itlead:
            //   return !eApprovedByITLeadStatus;
            case approverType.ithead:
              return !eApprovedByITHeadStatus;
            case approverType.assignee:
              return !eAssigneeStatus;
            default:
              return false;
          }
        }
      }
    }
  };

  const getButtonText = () => {
    if (approvalStep === approvalType && approvalStep === approverType.assignee) {
      return "Hoàn thành";
    } else {
      return "Đồng ý";
    }
  };

  /** Mail */

  const sendMail = async (status: string) => {
    const { fields } = Request;
    const url = siteUrl + "/details/" + Request.id;
    let template = mailtemplates.find((m: any) => m.eMailType === "ITRRA");
    let content = template.eContent;
    let subject = template.eSubject;
    let arrApprover = fields.eApprovedByITHead.split("|");
    let name = Request.createdBy.user.displayName;
    let tomail = Request.createdBy.user.email;
    let doing = "duyệt";
    if (status === requestStatus.rejected || approvalType === approverType.assignee) {
      template =
        status === requestStatus.rejected
          ? mailtemplates.find((m: any) => m.eMailType === "ITTRR")
          : mailtemplates.find((m: any) => m.eMailType === "ITRRF");
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, url);
      if (approvalType === approverType.assignee) {
        content = content.replace(mailRegexs.one, fields.eAssigneeComment || "");
      }
      subject = template.eSubject;
    } else {
      if (approvalType === approverType.approver) {
        arrApprover = fields.eApprovedByITHead.split("|");
      }
      // if (approvalType === approverType.itlead) {
      //   arrApprover = fields.eAssignee.split("|");
      //   doing = "thực hiện";
      // }
      if (approvalType === approverType.ithead) {
        arrApprover = fields.eAssignee.split("|");
        doing = "thực hiện";
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      name = arrApprover.length > 1 ? arrApprover[1] : "";
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", doing)
        .replace(mailRegexs.two + ";", Request.createdBy.user.displayName)
        .replace(mailRegexs.nine + ";", Request.id)
        .replace(mailRegexs.ten + ";", Request.fields.eDescription ?? "")
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(Request.createdDateTime)} - ${getHHmmFormat(Request.createdDateTime)}`,
        )
        .replace(mailRegexs.siteUrl, url);
      // if (approvalType === approverType.itlead) {
      //   const message = MailService.buildMailMesssage(subject, content, "html", "it@viags.vn");
      //   await MailService.sendMail(message);
      // }
    }

    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const sendMailForAssigned = () => {
    const url = siteUrl + "/details/" + Request.id;
    let template = mailtemplates.find((m: any) => m.eMailType === "ITRRA");
    let content = template.eContent;
    let subject = template.eSubject;
    assignList.forEach((e: any) => {
      const name = e.displayName;
      const tomail = e.userPrincipalName;
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", "thực hiện")
        .replace(mailRegexs.two + ";", Request.createdBy.user.displayName)
        .replace(mailRegexs.nine + ";", Request.id)
        .replace(mailRegexs.ten + ";", Request.fields.eDescription ?? "")
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(Request.createdDateTime)} - ${getHHmmFormat(Request.createdDateTime)}`,
        )
        .replace(mailRegexs.siteUrl, url);
      const message = MailService.buildMailMesssage(subject, content, "html", tomail);
      MailService.sendMail(message);
    });
  };

  const approveRequest = () => {
    const { fields } = Request;
    const dateApprove = getUCTDate();
    const historyList = fields.eUpdateHistory ? JSON.parse(fields.eUpdateHistory) : [];
    const createdHistory = {
      id: "",
      value: new Date(),
      modifiedDate: new Date(),
      user: name,
    };
    let fieldsChange = "";
    switch (approvalType) {
      case approverType.approver:
        if (assignList && assignList.length > 0) {
          sendMailForAssigned();
        }
        if (selectedITHead) {
          fields.eDeptHeadComment = comment;
          fields.eApprovedStatus = requestStatus.approved;
          fields.eApprovedDate = dateApprove;
          createdHistory.id = "approve";
          const approverTmp = getEmployeesByEmail(selectedITHead?.userPrincipalName);
          fields.eApprovedByITHead = approverTmp
            ? `${approverTmp.eMail}|${approverTmp.Title}|${approverTmp.eBizTitle}`
            : `${selectedITHead.userPrincipalName.toLowerCase()}|${selectedITHead.displayName}|${
                selectedITHead.jobTitle
              }`;
        } else {
          CreateNotification({
            title: "Vui lòng chọn người thực hiện",
            body: `Anh/Chị chưa chọn người thực hiện.`,
            icon: "/icons/warning.png",
          });
          return;
        }
        if (isThiennv) fieldsChange = "eApprovedBy";
        break;
      // case approverType.itlead:
      //   fields.eITLeadComment = comment;
      //   fields.eApprovedByITLeadStatus = requestStatus.approved;
      //   fields.eApprovedByITLeadDate = dateApprove;
      //   fields.eRequestStatus = requestStatus.inProgress;
      //   createdHistory.id = 'itlead';
      //   break;
      case approverType.ithead:
        fields.eITHeadComment = comment;
        fields.eApprovedByITHeadStatus = requestStatus.approved;
        fields.eApprovedByITHeadDate = dateApprove;
        fields.eRequestStatus = requestStatus.acceptance;
        createdHistory.id = "ithead";
        if (assignee) {
          const assigneeTmp = getEmployeesByEmail(assignee?.userPrincipalName);
          fields.eAssignee = assigneeTmp
            ? `${assigneeTmp.eMail}|${assigneeTmp.Title}|${assigneeTmp.eBizTitle}`
            : `${assignee.userPrincipalName}|${assignee.displayName}|${assignee.jobTitle}`;
        }
        if (isThiennv) fieldsChange = "eApprovedByITHead";
        break;
      case approverType.assignee:
        fields.eAssigneeComment = comment;
        fields.eAssigneeStatus = requestStatus.approved;
        fields.eAssigneeStatusDate = dateApprove;
        fields.eRequestStatus = requestStatus.completed;
        createdHistory.id = "assignee";
        if (listTSCC && Array.isArray(listTSCC)) {
          const promiseUpdateAssetCode: any[] = [];
          listTSCC.forEach((assetCode: string) => {
            promiseUpdateAssetCode.push(AssetService.updateNumberUpdate(assetCode));
          });
          Promise.all(promiseUpdateAssetCode);
        }
        if (isThiennv) fieldsChange = "eAssignee";
        break;
      default:
        break;
    }

    historyList.push(createdHistory);
    fields.eUpdateHistory = JSON.stringify(historyList);
    if (fieldsChange) fields[fieldsChange] = "thiennv@viags.vn|Nguyễn Văn Thiện|Đội trưởng - KCQ";
    mutate(
      { id: Request.id, body: fields },
      {
        onSuccess() {
          CreateNotification({
            title: "Thành công",
            body: `Đã duyệt thành công.`,
            icon: "/icons/success.png",
          });
          queryClient.invalidateQueries({ queryKey: ["repair-tools-requests", Request.id] });
          sendMail(requestStatus.approved);
        },
      },
    );
  };

  const recoverRequest = () => {
    const { fields } = Request;
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = "";
        fields.eApprovedStatus = "";
        fields.eApprovedDate = null;
        break;
      // case approverType.itlead:
      //   fields.eDeptHeadComment = "";
      //   fields.eApprovedByITLeadStatus = "";
      //   fields.eApprovedByITLeadDate = null;
      //   break;
      case approverType.ithead:
        fields.eITHeadComment = "";
        fields.eApprovedByITHeadStatus = "";
        fields.eApprovedByITHeadDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      case approverType.assignee:
        fields.eAssigneeComment = "";
        fields.eAssigneeStatus = "";
        fields.eAssigneeStatusDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      default:
        break;
    }
    mutate(
      { id: Request.id, body: fields },
      {
        onSuccess() {
          CreateNotification({
            title: "Thành công",
            body: `Thu hồi thành công.`,
            icon: "/icons/success.png",
          });
          queryClient.invalidateQueries({ queryKey: ["repair-tools-requests", Request.id] });
        },
      },
    );
  };

  const rejectRequest = () => {
    const { fields } = Request;
    let fieldsChange = "";

    if (!comment) {
      CreateNotification({
        title: "Thông báo",
        body: "Anh Chị vui lòng nhập lưu ý khi từ chối phê duyệt vào ô phía trên !",
        icon: "/icons/warning.png",
      });
      return;
    }
    fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = comment;
        fields.eApprovedStatus = requestStatus.rejected;
        fields.eApprovedDate = dateReject;
        if (isThiennv) fieldsChange = "eApprovedBy";

        break;
      // case approverType.itlead:
      //   fields.eITLeadComment = comment;
      //   fields.eApprovedByITLeadStatus = requestStatus.rejected;
      //   fields.eApprovedByITLeadDate = dateReject;
      //   break;
      case approverType.ithead:
        fields.eITHeadComment = comment;
        fields.eApprovedByITHeadStatus = requestStatus.rejected;
        fields.eApprovedByITHeadDate = dateReject;
        if (isThiennv) fieldsChange = "eApprovedByITHead";

        break;
      case approverType.assignee:
        fields.eAssigneeComment = comment;
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        if (isThiennv) fieldsChange = "eAssignee";

        break;
      default:
        break;
    }
    if (fieldsChange) fields[fieldsChange] = "thiennv@viags.vn|Nguyễn Văn Thiện";
    mutate(
      {
        id: Request.id,
        body: fields,
      },
      {
        onSuccess() {
          CreateNotification({
            title: "Thành công",
            body: `Từ chối thành công.`,
            icon: "/icons/success.png",
          });
          sendMail(requestStatus.rejected);
          queryClient.invalidateQueries({ queryKey: ["repair-tools-requests", Request.id] });
        },
      },
    );
  };

  const isApproved = checkApproval();
  const isEdit = checkEdit();
  const isCurrentUser = checkCreatedUser();

  const btnGroups = useMemo(() => {
    return [
      {
        hidden: !isCurrentUser || isApproved || !isEdit || isAdmin,
        content: (
          <Fragment>
            <Button
              className="mr10"
              buttonType="warning"
              label="Chỉnh sửa"
              onClick={() => {
                history.push(Routes.createRepairTools.path.replace(":id", Request.id));
              }}
            />
          </Fragment>
        ),
      },
      {
        hidden: !isApproved,
        content: [
          {
            hidden: approvalStep !== approvalType,
            content: [
              {
                hidden: false,
                content: (
                  <Fragment>
                    <Button className="mr10" buttonType="success" label={getButtonText()} onClick={approveRequest} />
                    <Button buttonType="grey" label="Không đồng ý" onClick={rejectRequest} className="mr10" />
                  </Fragment>
                ),
              },
              {
                hidden: !isCurrentUser || !isEdit || isAdmin,
                content: (
                  <Button
                    className="mr10"
                    buttonType="warning"
                    label="Chỉnh sửa"
                    onClick={() => history.push(Routes.createRepairTools.path.replace(":id", Request.id))}
                  />
                ),
              },
            ],
          },
          {
            hidden: approvalStep === approvalType,
            content: <Button buttonType="grey" label="Thu hồi" onClick={recoverRequest} />,
          },
        ],
      },
      {
        hidden: !isAdmin,
        content: (
          <Button
            className="ml10 mr5"
            buttonType="warning"
            label="Chỉnh sửa"
            onClick={() => history.push(Routes.createRepairTools.path.replace(":id", Request.id))}
          />
        ),
      },
      {
        content: (
          <Button
            className="ml5"
            buttonType="info"
            label="Tạo lại phiếu"
            onClick={() => {
              history.push(Routes.renewRepairTools.path.replace(":id", Request.id));
            }}
          />
        ),
      },
    ];
  }, [
    approvalStep,
    approvalType,
    approveRequest,
    isApproved,
    isEdit,
    isCurrentUser,
    Request.id,
    getButtonText,
    history,
    recoverRequest,
    rejectRequest,
    isAdmin,
  ]);

  // if (!(isCurrentUser && isEdit) && !isApproved && !isAdmin) {
  //   return null;
  // }

  return (
    <ButtonLayout smFixed>
      <ButtonGroup data={btnGroups} getItemHidden={(item) => item.hidden} renderContent={(item) => item.content} />
    </ButtonLayout>
  );
};

export default FormButton;
